import { fromJS } from 'immutable';
import { mergeEntity, normalizeEntities } from 'helpers/utilHelpers';
import {
  DELETE_LEGAL_ENTITY_SUCCESS,
  LOAD_CLIENTS_SUCCESS,
  LOAD_LEGAL_ENTITIES_SUCCESS,
  UPDATE_LEGAL_ENTITY_SUCCESS,
  LOAD_CLIENT_BY_ID_SUCCESS,
  LOAD_CLIENTS_TABLE_SUCCESS,
  LOAD_COMPANIES_SUCCESS,
  LOAD_CLIENT_INVOICE_BY_ID_SUCCESS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  entities: {},
});

const legalEntitiesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CLIENTS_TABLE_SUCCESS: {
      const entities = [];
      if (action.clients.items) {
        action.clients.items.forEach((client) => {
          if (client && client.entities) {
            client.entities.forEach((entity) => {
              if (entity) {
                entities.push({ ...entity });
              }
            });
          }
        });
        return state.set('entities', normalizeEntities(entities, 'entityId', state.get('entities')));
      }
      return state;
    }
    case LOAD_CLIENT_BY_ID_SUCCESS: {
      if (action.values && action.values.entities) {
        const entities = [];
        action.values.entities.forEach((entity) => entities.push({ ...entity }));

        return state.set('entities', normalizeEntities(entities, 'entityId', state.get('entities')));
      }
      return state;
    }
    case LOAD_CLIENTS_SUCCESS: {
      const entities = [];
      action.clients.items.forEach((client) => {
        client.entities && client.entities.forEach((entity) => entities.push(entity));
      });

      return state.set('entities', normalizeEntities(entities, 'entityId', state.get('entities')));
    }
    case LOAD_LEGAL_ENTITIES_SUCCESS:
      return state.set('entities', normalizeEntities(action.entities.items, 'entityId', state.get('entities')));
    case UPDATE_LEGAL_ENTITY_SUCCESS: {
      const entity = { ...action.entity };
      return state.setIn(
        ['entities', entity.entityId],
        mergeEntity(entity, state.getIn(['entities', entity.entityId])),
      );
    }
    case DELETE_LEGAL_ENTITY_SUCCESS:
      return state.deleteIn(['entities', action.entityId]);
    case LOAD_COMPANIES_SUCCESS: {
      let entities = [];
      action.companies.items.forEach((company) => {
        if (company.legalEntities?.length) {
          entities = entities.concat(company.legalEntities);
        }
      });
      return state.set('entities', normalizeEntities(entities, 'entityId', state.get('entities')));
    }
    case LOAD_CLIENT_INVOICE_BY_ID_SUCCESS: {
      if (action.invoice.clientEntity) {
        return state.setIn(
          ['entities', action.invoice.clientEntity.entityId],
          mergeEntity(action.invoice.clientEntity, state.getIn(['entities', action.invoice.clientEntity.entityId])),
        );
      }
      return state;
    }
    default:
      return state;
  }
};

export default legalEntitiesReducer;
